import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HubFavouritesContainer } from './styles';
import FavouritesBar from './FavouritesBar';
import FavouritesTable from './FavouritesTable';
import LocalStorageUtility from '../../common/localStorageUtility/localStorageUtility';
import Label from '../../components/shared/Label';
import LoadingDot from '../../components/LoadingDot';
import DifferentTZS from '../../components/shared/DifferentTZS';

const observeDOM = ((() => {
  const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  const eventListenerSupported = window.addEventListener;

  return (obj, callback) => {
    if (MutationObserver) {
      // define a new observer
      const obs = new MutationObserver((mutations) => {
        if (mutations[0].addedNodes.length || mutations[0].removedNodes.length) {
          callback();
          setTimeout(() => obs.disconnect(), 1000);
        }
      });
      // have the observer observe foo for changes in children
      obs.observe(obj, { childList: true, subtree: true });
    } else if (eventListenerSupported) {
      obj.addEventListener('DOMNodeInserted', callback, false);
      obj.addEventListener('DOMNodeRemoved', callback, false);
    }
  };
}))();

export class HubFavourites extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }
  componentDidMount() {
    const urlParams = {
      yesterdaySportIds: JSON.stringify({ sportIds: LocalStorageUtility.getYesterdaySportIds() }),
      tomorrowSportIds: JSON.stringify({ sportIds: LocalStorageUtility.getTomorrowSportIds() }),
    };
    this.resizeCallback();
    window.addEventListener('resize', this.resizeCallback);
    this.props.actions.getYesterdayTomorrow(urlParams);
    LocalStorageUtility.getTodaySportIds().forEach((sportId) => {
      this.props.actions.getToday('today', sportId);
    });
    this.props.actions.setIsDifferentTZS(false);
    // Observe a specific DOM element:
    observeDOM(document.querySelector('html'), () => {
      const todayFavTable = document.querySelector('#todayfavtable');
      const nowLive = document.querySelector('.nowLive');
      const isLiveArrow = document.querySelector('#isLiveArrow');

      if (this.state.isMobile) {
        if (todayFavTable != null) {
          todayFavTable.scrollIntoView();
          window.scrollBy(0, -50);
        } else {
          window.scrollTo(0, 0);
        }
      }
      if (nowLive != null && isLiveArrow != null) {
        isLiveArrow.style.opacity = '1';
      } else if (isLiveArrow != null && nowLive == null) {
        isLiveArrow.style.opacity = '0';
      }
    });
  }

  componentDidUpdate() {
    // Observe a specific DOM element:
    observeDOM(document.querySelector('html'), () => {
      const nowLive = document.querySelector('.nowLive');
      const isLiveArrow = document.querySelector('#isLiveArrow');

      if (nowLive != null && isLiveArrow != null) {
        isLiveArrow.style.opacity = '1';
      } else if (isLiveArrow != null && nowLive == null) {
        isLiveArrow.style.opacity = '0';
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
  }

  getDateTime(datetime) {
    switch (datetime) {
      case ('today'):
        return this.dateTimeHandler(new Date());
        //eslint-disable-next-line
      case ('tomorrow'):
        const tomorrow = new Date();
        return this.dateTimeHandler(new Date(tomorrow.setDate(tomorrow.getDate() + 1)));
        //eslint-disable-next-line
      case ('yesterday'):
        const yesterday = new Date();
        return this.dateTimeHandler(new Date(yesterday.setDate(yesterday.getDate() - 1)));
      default:
        break;
    }
    return true;
  }

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= this.dynamicBreakPointWindow(process.env.REACT_APP_SITE),
    });
  };

  dynamicBreakPointWindow = (site) => {
    if (site === 'gazzetta') {
      return 1023;
    } else if (site === 'fcinter' || site === 'calcionapoli1926' || site === 'forzaroma') {
      return 980;
    } else if (site === 'corriere') {
      return 767;
    } else {
      return 1023;
    }
  };

  dateTimeHandler = (datetime) => {
    const month = this.props.dictionary.date.months[datetime.getMonth()];
    const day = datetime.getDate();
    return `${day} ${month}`;
  };

  showLoading = () => {
    if (this.props.favouritesCounter === 0) { return false; }
    const hasYesterday = !this.props.yesterday || (this.props.yesterday.size === 0 && LocalStorageUtility.hasSportIds('yesterday'));
    const hasToday = !this.props.today || (this.props.today.size === 0 && LocalStorageUtility.hasSportIds('today'));
    const hasTomorrow = !this.props.tomorrow || (this.props.tomorrow.size === 0 && LocalStorageUtility.hasSportIds('tomorrow'));
    if (hasYesterday || hasToday || hasTomorrow) { return true; }
    return false;
  }

  render() {
    const {
      actions, favouritesCounter, location, today,
      tomorrow, yesterday, dictionary, isDifferentTZS,
    } = this.props;
    const { isMobile } = this.state;
    return (
      <HubFavouritesContainer>
        <FavouritesBar
          actions={actions}
          favouritesCounter={favouritesCounter}
          location={location}
          isMobile={isMobile}
        />
        {favouritesCounter < 1 &&
        <div>
          <Label
            label="Non sono presenti eventi nei tuoi Preferiti."
            margin="0px 0px 20px 0px"
          />
        </div>
        }
        {<LoadingDot show={this.showLoading()} />}
        {isDifferentTZS && favouritesCounter > 0 && <DifferentTZS />}
        {LocalStorageUtility.getYesterdaySportIds().length > 0 && yesterday && yesterday.size > 0 &&
          <FavouritesTable
            sportDay={yesterday}
            sportDate={`Ieri ${this.getDateTime(this.props.dictionary.filterBar.dropdown[0].value)}`}
            actions={actions}
            dictionary={dictionary}
            sportsForDay={LocalStorageUtility.getYesterdaySportIds()}
            date={this.props.dictionary.filterBar.dropdown[0].value}
            isMobile={isMobile}
          />
        }
        {LocalStorageUtility.getTodaySportIds().length > 0 && today && today.size > 0 &&
        <div id="todayfavtable">
          <FavouritesTable
            sportDay={today}
            sportDate={`Oggi ${this.getDateTime(this.props.dictionary.filterBar.dropdown[1].value)}`}
            actions={actions}
            dictionary={dictionary}
            sportsForDay={LocalStorageUtility.getTodaySportIds()}
            date={this.props.dictionary.filterBar.dropdown[1].value}
            isMobile={isMobile}
            isToday
            isDeskFav
          />
        </div>
        }
        {LocalStorageUtility.getTomorrowSportIds().length > 0 && tomorrow && tomorrow.size > 0 &&
          <FavouritesTable
            sportDay={tomorrow}
            sportDate={`Domani ${this.getDateTime(this.props.dictionary.filterBar.dropdown[2].value)}`}
            actions={actions}
            dictionary={dictionary}
            sportsForDay={LocalStorageUtility.getTomorrowSportIds()}
            date={this.props.dictionary.filterBar.dropdown[2].value}
            isMobile={isMobile}
          />
        }
      </HubFavouritesContainer>
    );
  }
}

HubFavourites.propTypes = {
  actions: PropTypes.any,
  favouritesCounter: PropTypes.number,
  location: PropTypes.any,
  today: PropTypes.any,
  tomorrow: PropTypes.any,
  yesterday: PropTypes.any,
  dictionary: PropTypes.any,
  isDifferentTZS: PropTypes.any,
};

export default HubFavourites;
